import React, { useEffect, useState } from "react";
import ArticleCard from "./sections/articleCard/ArticleCard";
import PromotinalFeatures from "./sections/PromotionalFeatures/PromotionalFeatures";
import BenefitArticleCard from "./sections/benefitArticleCard/BenefitArticleCard";
// import { TiTick } from "react-icons/ti";
import "./home.scss";

const Home: React.FC = (): JSX.Element => {
	const handleArticleCardClick = () => {
		const contentToScrollTo = document.getElementById("articleCard");

		if (contentToScrollTo) {
			contentToScrollTo.scrollIntoView({ behavior: "smooth" });
		}
	};

	const enrollmentStartDate = new Date("March 24, 2025").getTime();
	// const enrollmentEndDate = new Date("April 30, 2025").getTime();
	const currentDate = new Date().getTime();

	const [timeLeft, setTimeLeft] = useState(enrollmentStartDate - currentDate);

	const formatTime = (time: number) => {
		const days = Math.floor(time / (1000 * 60 * 60 * 24));
		const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((time % (1000 * 60)) / 1000);
		return `${days}d ${hours}h ${minutes}m ${seconds}s`;
	};

	const redirectMemberPortal = () => {
		const path = "https://admin.enrollment.nexcaliber.com";
		window.open(path);
	};

	useEffect(() => {
		if (timeLeft > 0) {
			const timer = setInterval(() => {
				setTimeLeft(enrollmentStartDate - new Date().getTime());
			}, 1000);
			return () => clearInterval(timer);
		}
	}, [enrollmentStartDate, timeLeft]);

	return (
		<div className="home-main-container">
			<header className="landing">
				<div className="header-content">
					<h1>Access Quality Healthcare Anywhere</h1>
					<h1>Enroll with Confidence</h1>
					<p className="para">
						Brookshire Brothers has kicked off its annual enrollment period with gusto. We aim to connect
						with more individuals, ensuring everyone has access to vital health benefits
					</p>

					<div className="light">
						<div className="neon">{timeLeft > 0 ? "Enrollment will be Live" : "Enrollment is Live"}</div>
					</div>

					<h4 className="date">March 23th, 2026 - April 30th, 2026</h4>

					{timeLeft > 0 ? (
						<div className="countdown">
							Starts in:<span style={{ color: "white" }}> {formatTime(timeLeft)}</span>
						</div>
					) : (
						<button className="pulse-buttons" onClick={redirectMemberPortal}>
							Enroll Now
						</button>
					)}
				</div>
				{/* <button className="btn third">Button 3</button> */}
			</header>

			<div className="subsection-section-1">
				<div className="subsection-text">
					Easy & quick process to get life and health insurance.&nbsp;
					<span className="get-more-text" onClick={handleArticleCardClick}>
						Get more info
					</span>
				</div>
			</div>

			<div className="other-section-container-article">
				<ArticleCard />
			</div>

			<div className="">
				<PromotinalFeatures />
			</div>

			<div id="articleCard">
				<div id="other-section-container-benefit-article" className="other-section-container-benefit-article">
					<BenefitArticleCard />
				</div>
			</div>
		</div>
	);
};

export default Home;
